import { createSelector } from '@reduxjs/toolkit';
import { selectSIPHandRaisedIds, selectSIPUserEntities } from 'features/sip/sipSlice';
import { selectLocalUser } from 'features/users/usersSlice';
import { selectPermissionsState } from 'features/permissions/permissionsSlice';
import { refinePermissions } from 'features/permissions/utils/refinePermissions';
import { PermissionTypes } from 'features/permissions/types';

export const selectSIPHandRaisedUsers = createSelector(
  [selectSIPUserEntities, selectSIPHandRaisedIds, selectLocalUser, selectPermissionsState],
  (sipEntities, handRaisedIds, localUser, permissionsState) => {
    const canManagePhoneUsers = refinePermissions(PermissionTypes.managePhoneUsers, {
      permissionsState,
      localUser,
    });

    if (!canManagePhoneUsers) {
      return [];
    }

    return handRaisedIds.map((id: string) => sipEntities[id]);
  }
);
